import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("checking");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) { setStatus("error"); setMsg("Lien invalide"); return; }
    let active = true;
    (async () => {
      try {
        await api.post("/auth/verify-email", { token });
        if (active) setStatus("success");
      } catch (err) {
        if (active) {
          setStatus("error");
          setMsg(err.response?.data?.detail || "Erreur");
        }
      }
    })();
    return () => { active = false; };
  }, [token]);

  return (
    <div className="container mx-auto px-4 py-20 max-w-md text-center">
      {status === "checking" && (
        <>
          <Loader2 className="mx-auto animate-spin text-brand" size={56} />
          <h1 className="mt-6 font-display text-3xl font-black text-ink">Vérification…</h1>
        </>
      )}
      {status === "success" && (
        <div data-testid="verify-success">
          <CheckCircle2 className="mx-auto text-[#34C759]" size={64} />
          <h1 className="mt-6 font-display text-3xl font-black text-ink">Email vérifié</h1>
          <p className="mt-2 text-subtle">Votre compte est confirmé. Vous pouvez utiliser BypassGo normalement.</p>
          <Button asChild className="mt-8 h-12 bg-brand hover:bg-brand-hover text-white rounded-md px-8" data-testid="back-home-btn">
            <Link to="/">Retour à l'accueil</Link>
          </Button>
        </div>
      )}
      {status === "error" && (
        <div data-testid="verify-error">
          <XCircle className="mx-auto text-destructive" size={64} />
          <h1 className="mt-6 font-display text-3xl font-black text-ink">Échec de la vérification</h1>
          <p className="mt-2 text-subtle">{msg}</p>
          <Button asChild className="mt-8 h-12 bg-ink hover:bg-brand text-white rounded-md px-8">
            <Link to="/">Retour à l'accueil</Link>
          </Button>
        </div>
      )}
    </div>
  );
}
